<template>
<pop-up-layout 
  :title="$t('promociones.cuenta')"
  :aceptar="$t('general.misc.guardarCambios')"
  :loading="loading"
  :saving="waitingForLoad"
  :loadingText="$t('general.misc.cargando')"
  :disabled="!cambiado"
  @volver="$parent.hide()"
  @aceptar="guardar()"
  :description="$t('promociones.textoCuenta', {promo: promocion.descripcion})"
>
<v-form ref="form" v-model="valid">
  <v-layout row justify-center="">
    <v-flex xs10 lg6>
      <v-text-field
        v-model="cuentaTransferencia"
        :label="$t('promociones.cuenta')"
        :rules="[rules.required, rules.max(256)]"
        :placeholder="$t('promociones.cuentaPlaceholder')"
      />
    </v-flex>
  </v-layout>
  </v-form>
</pop-up-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import rulesMixin from '@/mixins/rules.js'
export default {
  mixins: [rulesMixin],
  props: {
    codigoPromocion: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      waitingForLoad: false,
      cambiadoData: false,
      loading: true,
      valid: true,
      oldCuentaTransferencia: null,
      cuentaTransferencia: null
    }
  },
  async created () {
    try {
      this.loading = true
      await this.loadPromocion(this.codigoPromocion)
      this.cuentaTransferencia = this.promocion.cuentaTransferencia ? this.promocion.cuentaTransferencia.valor : null
      this.oldCuentaTransferencia = this.cuentaTransferencia
      this.cambiadoData = false
      this.loading = false
      this.$emit('cambiado', false)
    } catch (error) {
      this.waitingForLoad = false
      if (!error.code || error.code !== 1) {
        this.addAlert({texto: error.message, color: 'error'})
      }
    }
  },
  mounted () {
    window.addEventListener('beforeunload', this.alertPreRefresh)
  },
  beforeDestroy () {
    this.$emit('cambiado', false)
    window.removeEventListener('beforeunload', this.alertPreRefresh)
  },
  computed: {
    ...mapGetters({
      promocion: 'promociones/getActual'
    }),
    cambiado () {
      if (this.cambiadoData) {
        return true
      }
      // eslint-disable-next-line
      this.cambiadoData = this.cambiadoData || this.oldCuentaTransferencia !== this.cuentaTransferencia
      this.$emit('cambiado', this.cambiadoData)
      return this.cambiadoData
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      loadPromocion: 'promociones/loadPromocion',
      modificarCuentaTransferencia: 'promociones/modificarCuentaTransferencia'
    }),
    alertPreRefresh (e) {
      if (this.cambiado) {
        let message = this.$t('general.misc.alertPreRefresh')
        e = e || window.event
        // For IE and Firefox prior to version 4
        if (e) {
          e.returnValue = message
        }
        // For Safari
        return message
      }
    },
    async guardar () {
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t('general.misc.revisaCamposRojo'), color: 'error'})
        return
      }
      try {
        this.waitingForLoad = true
        this.$parent.noCerrarInterno = true
        await this.modificarCuentaTransferencia({
          codigoPromocion: this.codigoPromocion,
          cuentaTransferencia: this.cuentaTransferencia
        })
        this.$emit('cambiado', false)
        this.$emit('recargar')
        this.$parent.hide()
        this.waitingForLoad = false
        this.$parent.noCerrarInterno = false
        this.addAlert({texto: this.$t('general.misc.datosGuardadosExito'), color: 'success'})
      } catch (error) {
        this.waitingForLoad = false
        this.$parent.noCerrarInterno = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/promociones/PopUpCuentaCorriente.vue